import { IIntegration, ILoadableArray, ILoadableWrapper, createDefaultILoadableArray } from "../../models"
import { IBlueprint } from "../../models/integration.interface";

export interface IntegrationsState {
  integrations: ILoadableArray<ILoadableWrapper<IIntegration>>;
  blueprints: ILoadableArray<IBlueprint>
}

export const initialIntegrationState: IntegrationsState = {
  integrations: createDefaultILoadableArray<ILoadableWrapper<IIntegration>>(),
  blueprints:createDefaultILoadableArray<IBlueprint>()
};


